import { render, staticRenderFns } from "./orderGoodsInfo.vue?vue&type=template&id=41d05f4e&scoped=true&"
import script from "./orderGoodsInfo.vue?vue&type=script&lang=js&"
export * from "./orderGoodsInfo.vue?vue&type=script&lang=js&"
import style0 from "./orderGoodsInfo.vue?vue&type=style&index=0&id=41d05f4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d05f4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41d05f4e')) {
      api.createRecord('41d05f4e', component.options)
    } else {
      api.reload('41d05f4e', component.options)
    }
    module.hot.accept("./orderGoodsInfo.vue?vue&type=template&id=41d05f4e&scoped=true&", function () {
      api.rerender('41d05f4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/module/orderGoodsInfo.vue"
export default component.exports